export enum LinkDisplay {
    all,
    auth,
    unauth
}
